/* eslint-disable @next/next/no-img-element */
import type { FC, ReactNode } from 'react'

import Link from 'next/link'

type PageHeroProps = {
    badge?: string
    eyebrow?: string
    eyebrowHref?: string
    title: ReactNode
    description?: ReactNode
    showButtons?: boolean
}

/**
 * Shared inner-page hero (the Webflow `.section-hero`). Uses the same class
 * names the page-load animation targets (`.hero-top-content`, `.main-heading`,
 * `.hero-description`, `.download-buttons`), so every page animates in on load.
 */
export const PageHero: FC<PageHeroProps> = ({
    badge,
    eyebrow,
    eyebrowHref = '#',
    title,
    description,
    showButtons = false
}): ReactNode => {
    return (
        <div className='section-hero'>
            <div className='main-hero-container'>
                <div className='small-container'>
                    <div className='text-center'>
                        {(badge || eyebrow) && (
                            <div className='hero-link-holder'>
                                <div className='text-hidden'>
                                    <div className='hero-top-content'>
                                        <Link href={eyebrowHref} className='hero-link w-inline-block'>
                                            {badge && <div className='link-new-badge'>{badge}</div>}
                                            <div>{eyebrow}</div>
                                            <div className='hero-link-arrow' />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        )}

                        <h1 className='main-heading'>{title}</h1>

                        {description && (
                            <div className='w-layout-grid grid-10-columns'>
                                <p className='hero-description'>{description}</p>
                            </div>
                        )}

                        {showButtons && (
                            <div className='download-buttons hero-download-buttons'>
                                <div className='download-button'>
                                    <a href='https://apple.com' target='_blank' rel='noreferrer' className='button black-button w-inline-block'>
                                        <img src='/images/Apple-Icon.svg' loading='lazy' alt='' className='download-button-icon' />
                                        <div>
                                            <span className='hide-on-mobile'>Download for </span>iOS
                                        </div>
                                    </a>
                                </div>
                                <div className='download-button'>
                                    <a href='https://play.google.com/store/apps' target='_blank' rel='noreferrer' className='button black-button w-inline-block'>
                                        <img src='/images/Android-Icon.svg' loading='lazy' alt='' className='download-button-icon' />
                                        <div>
                                            <span className='hide-on-mobile'>Download for </span>Android
                                        </div>
                                    </a>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}
